import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

interface BookingConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  bookingDetails: {
    amenityName: string;
    date: string;
    slot: any;
    price: number;
    specialRequest?: string;
  };
}

const BookingConfirmationModal: React.FC<BookingConfirmationModalProps> = ({ show, onHide, onConfirm, bookingDetails }) => {
  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Your Booking</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2"><strong>Amenity:</strong> {bookingDetails.amenityName}</div>
        <div className="mb-2"><strong>Date:</strong> {bookingDetails.date}</div>
        <div className="mb-2"><strong>Time:</strong> {bookingDetails.slot.start_time} - {bookingDetails.slot.end_time}</div>
        <div className="mb-2"><strong>Price:</strong> ₹{bookingDetails.price}</div>
        {bookingDetails.specialRequest && (
          <div className="mb-2"><strong>Special Request:</strong> {bookingDetails.specialRequest}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="success" onClick={onConfirm}>
          Confirm Booking
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BookingConfirmationModal; 